var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interior-designer-form"},[_c('applications-interior-designer-header'),_c('applications-interior-designer-steps')],1)}
var staticRenderFns = []

export { render, staticRenderFns }